/**
 * Static banner surfaced below the main Metric View grid, warning users about
 * two known data-quality caveats on the Product Flow metrics. Purely
 * informational — no data, no link (catalog target dropped for v1).
 */
export function QualityCaveatsBanner() {
  return (
    <div
      role="note"
      aria-label="Product Flow quality caveats"
      className="flex items-start gap-3 rounded-md border border-border bg-muted/30 px-4 py-3"
    >
      <span
        aria-hidden="true"
        className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-muted-foreground text-[11px] font-semibold text-muted-foreground"
      >
        i
      </span>
      <div className="space-y-1">
        <p className="text-sm font-semibold text-foreground">
          Two Product Flow metrics have quality caveats
        </p>
        <p className="text-xs text-muted-foreground">
          Cycle Time depends on teams passing tickets through <em>In Progress</em>
          {' '}(NextPM skips this and is excluded from this average). WIP accuracy
          depends on a shared taxonomy of &ldquo;in-progress&rdquo; states —
          flagged in the Catalog as a Tech Org priority.
        </p>
      </div>
    </div>
  );
}
